var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4047 14.2043C24.4047 15.4201 23.4201 16.4067 22.2024 16.4067C20.9866 16.4067 20 15.4201 20 14.2043C20 12.9885 20.9866 12 22.2024 12C23.4201 12 24.4047 12.9885 24.4047 14.2043ZM24.4047 21.9994C24.4047 23.2152 23.4201 24.2037 22.2024 24.2037C20.9866 24.2037 20 23.2152 20 21.9994C20 20.7836 20.9866 19.797 22.2024 19.797C23.4201 19.797 24.4047 20.7836 24.4047 21.9994ZM22.2024 32.0006C23.4201 32.0006 24.4047 31.014 24.4047 29.7982C24.4047 28.5824 23.4201 27.5939 22.2024 27.5939C20.9866 27.5939 20 28.5824 20 29.7982C20 31.014 20.9866 32.0006 22.2024 32.0006Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreBtn);
export default __webpack_public_path__ + "static/media/moreBtn.0d57f303b92a7f2f6fb0ed614a98932e.svg";
export { ForwardRef as ReactComponent };